import script from "./ModelagemPrecos.vue?vue&type=script&setup=true&lang=js"
export * from "./ModelagemPrecos.vue?vue&type=script&setup=true&lang=js"

import "./ModelagemPrecos.vue?vue&type=style&index=0&id=3508d0d9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3508d0d9"]])

export default __exports__